import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

import './index.scss';

interface IShortcutEditAddButtonProps extends IBaseProps {
  disabled?: boolean;
  addText: string;
  onAdd?: () => void;
}

const ShortcutEditAddButton: React.FC<IShortcutEditAddButtonProps> = (props) => {
  const { style, className, disabled = false, addText, onAdd } = props;

  const handleClick = (): void => {
    if (disabled) {
      return;
    }

    onAdd?.();
  };

  return (
    <button
      style={style}
      className={classnames('dbh-shortcut-edit-add-button', className)}
      type="button"
      disabled={disabled}
      onClick={handleClick}
    >
      <SvgIcon className="dbh-shortcut-edit-add-button__icon" type="icon_add_game" />
      <span className="dbh-shortcut-edit-add-button__text">{addText}</span>
    </button>
  );
};

export default ShortcutEditAddButton;
